import React, { useEffect } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import Home from '@common/screens/RenderScreen/Home';
import RenderScreen from '@common/screens/RenderScreen';
import history from './history';

export default function AppRoutes() {
  useEffect(() => {
    // Listen for the response
    window.addEventListener('message', function (event) {
      try {
        // Verify the origin of the message
        if (event?.data?.type === 'click__get__cookie') {
          const cookie = event.data.cookie;
          console.log('=== Cookie received:', cookie);
          localStorage.setItem('click__cookie', cookie);
        }
        if (event?.data?.type === 'click__get__current_url') {
          const currentUrl = event.data.currentUrl;
          console.log('=== currentUrl received:', currentUrl);
          localStorage.setItem('click__current_url', currentUrl);
        }
      } catch (error) {
        console.error('=== error', error);
        // do nothing
      }
    });
  }, []);

  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/preview/:appId" component={RenderScreen} />
        <Route path="/:appId" component={RenderScreen} />
      </Switch>
    </Router>
  );
}
